var _circle, _circle2, _ellipse, _path, _path2, _path3, _path4, _path5, _ellipse2, _path6, _path7, _ellipse3, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorried(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 102,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 98,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 79,
    ry: 80,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 84 Q74 76 84 83",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 86 Q76 78 86 85",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116 84 Q128 82 140 85",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 86 Q130 84 142 87",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104 Q74 94 86 104",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 106,
    rx: 12,
    ry: 8,
    fill: "#111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 106 Q76 96 88 106",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 102 Q127 90 140 103",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127,
    cy: 105,
    rx: 12,
    ry: 11,
    fill: "#111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116 104 Q129 92 142 105",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 142 Q100 128 136 140",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70 144 Q102 130 138 142",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M148 108 C148 100 156 92 160 100 C160 110 154 116 148 108Z",
    fill: "#00CCCC",
    opacity: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151 109 C151 101 159 93 163 101 C163 111 157 117 151 109Z",
    fill: "#FF00FF",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorried);
export default __webpack_public_path__ + "static/media/worried.3620d1d8cc7f8449832c8934cf5642e7.svg";
export { ForwardRef as ReactComponent };